module.exports = __webpack_public_path__ + "static/media/nav-icon1.05fc57db.svg";